export default __webpack_public_path__ + "static/media/monthly.e93974a5.svg";